import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m22.447 12.969-3-7.5a.75.75 0 0 0-.86-.454L12.75 6.313V4.25a.75.75 0 1 0-1.5 0v2.398l-6.163 1.37a.75.75 0 0 0-.534.45v.006l-3 7.495a.7.7 0 0 0-.053.281c0 2.185 2.3 3 3.75 3s3.75-.815 3.75-3a.7.7 0 0 0-.053-.281L6.274 9.29l4.976-1.104V20h-1.5a.75.75 0 1 0 0 1.5h4.5a.75.75 0 1 0 0-1.5h-1.5V7.852l4.781-1.061-2.477 6.178a.7.7 0 0 0-.054.281c0 2.185 2.3 3 3.75 3s3.75-.815 3.75-3a.7.7 0 0 0-.053-.281M5.25 17.75c-.706 0-2.134-.338-2.243-1.372l2.243-5.609 2.243 5.609c-.11 1.034-1.537 1.372-2.243 1.372m13.5-3c-.706 0-2.134-.338-2.243-1.373L18.75 7.77l2.244 5.608c-.11 1.035-1.538 1.373-2.244 1.373"
    }, null, -1)
  ])))
}
export default { render: render }